import updateQueryParam from "@casino/client/utils/updateQueryParam/updateQueryParam";
import debounce from "@casino/shared/utils/debounce/debounce";
import { useRouter } from "next/navigation";
import { useCallback, useState } from "react";
import getCurrentSortParams from "./helper/getCurrentSortParams";

const useSortFilter = (sortParams: string | undefined) => {
  const paramsData = getCurrentSortParams(sortParams);
  const router = useRouter();
  const [sort, setSort] = useState(paramsData);

  const updateURL = debounce((selected: SelectedSort) => {
    setSort(selected);
    const newPathQuery = updateQueryParam(
      location.href,
      "sort",
      `${selected.name}:${selected.value}`,
    );
    router.push(newPathQuery);
  }, 100);

  const handleSelect = useCallback(
    (name: SelectedSort["name"]) => {
      if (name === sort.name) {
        return updateURL({ name, value: sort.value === 1 ? -1 : 1 });
      }
      return updateURL({ name, value: name === "name" ? 1 : -1 });
    },
    [sort.name, sort.value, updateURL],
  );

  return { sort, handleSelect };
};

export default useSortFilter;
